import Head from "next/head";

import classNames from "classnames";

import ApplicationLayout from "components/ApplicationLayout";
import Navbar from "components/Navbar";
import PageContent from "components/PageContent";
import Container from "components/Container";
import SharedFooter from "components/SharedFooter";

import styles from "./MarkdownLayout.module.css";

type MarkdownLayoutProps = {
  meta: {
    title: string;
    desc: string;
  };
  children: string | React.ReactNode;
  details?: React.ReactNode;
  separatedIntro?: boolean;
};

const MarkdownLayout = ({ meta, children, details, separatedIntro = true }: MarkdownLayoutProps) => {
  return (
    <>
      {meta !== undefined && meta.title !== undefined ? (
        <Head>
          <title>Raycast – {meta.title}</title>
        </Head>
      ) : null}
      <ApplicationLayout>
        <Navbar />
        <PageContent>
          <Container>
            <div className={classNames(styles.intro, styles.wrapper, { [styles.separated]: separatedIntro })}>
              <h1 className={classNames(styles.title)}>{meta.title}</h1>
              {meta.desc ? <p className={styles.description}>{meta.desc}</p> : null}
              {details}
            </div>
            <div className={classNames(styles.wrapper, "markdown")}>{children}</div>
          </Container>
        </PageContent>
        <SharedFooter />
      </ApplicationLayout>
    </>
  );
};

export default MarkdownLayout;
